import { render, staticRenderFns } from "./select-student.vue?vue&type=template&id=051d2176&scoped=true&"
import script from "./select-student.vue?vue&type=script&lang=js&"
export * from "./select-student.vue?vue&type=script&lang=js&"
import style0 from "./select-student.vue?vue&type=style&index=0&id=051d2176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d2176",
  null
  
)

export default component.exports